import NotificationsView from './NotificationsView';

export default NotificationsView;
